import { useIntl } from 'react-intl';
import { Helmet } from 'react-helmet';
import { Badge, Divider, Typography } from 'antd';

import { PageProps } from '@/types/PageProps';
import { useWindowSize } from '@/hooks';
import { useState } from 'react';
import TabsCustom from '@/components/_common/TabsCustom';
import CustomerRecommendationSettings from '@/components/Settings/Customer/Recommendation';
import CustomerConfigurationSettings from '@/components/Settings/Customer/Configuration';
import CustomerCategorySettings from '@/components/Settings/Customer/Category';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import Authorities from '@/types/Authority';

const { Title } = Typography;

export const initialTabErrors = {
  recommendation: false,
  category: false,
  configuration: false,
};

export default function CustomerSettingsPage({ route }: PageProps) {
  const intl = useIntl();

  const { width } = useWindowSize();

  const [menuKeyActive, setMenuKeyActive] = useState<string>('recommendation');
  const [tabErrors, setTabErrors] = useState(initialTabErrors);

  function handleTabError(key: keyof typeof initialTabErrors) {
    setTabErrors((state) => ({ ...state, [key]: true }));
  }

  return (
    <>
      <Helmet title={intl.formatMessage({ id: route.name })} />

      <div className="page-header">
        <Title level={width < 576 ? 5 : 4}>
          {intl.formatMessage({ id: route.name })}
        </Title>
      </div>

      <Divider />

      <TabsCustom
        key={menuKeyActive}
        activeKey={menuKeyActive}
        onChange={setMenuKeyActive}
      >
        <TabsCustom.Item
          icon={tabErrors?.recommendation ? <Badge dot /> : null}
          label="Recomendações"
          key="recommendation"
        >
          <CustomerRecommendationSettings handleTabError={handleTabError} />
        </TabsCustom.Item>

        {hasPermissions([
          Authorities.CONFIGURATION_MATRIX_SETTINGS_VIEW_CUSTOMER,
        ]) && (
          <TabsCustom.Item
            icon={tabErrors?.category ? <Badge dot /> : null}
            label="Configuração"
            key="configuration"
          >
            <CustomerConfigurationSettings
              handleTabError={handleTabError}
              menuActive={menuKeyActive === 'configuration'}
            />
          </TabsCustom.Item>
        )}

        <TabsCustom.Item
          icon={tabErrors?.category ? <Badge dot /> : null}
          label="Categorias"
          key="category"
        >
          <CustomerCategorySettings
            handleTabError={handleTabError}
            menuActive={menuKeyActive === 'category'}
          />
        </TabsCustom.Item>
      </TabsCustom>
    </>
  );
}
